<script>
import moment from "moment";
import {money_format} from "@/utils";
import UpdateLocationModal from "@/view/components/locations/UpdateLocationModal.vue";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";

export default {
  name: "locations-report",
  components: {
    UpdateLocationModal,
    DataTableSection
  },
  data() {
    return {
      search: "",
      selected: [],
      sort: true,
      items: [],
      item: null,
      snackbar: false,
      text: "Loading locations...",
      timeout: 2000,
      loading: true,
      tableDataParam: {
        getters: 'getLocationsFix',
        dispatchFunction: 'getLocations',
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: true,
            value: "name",
            width: "150px"
          },
          {text: "Street", value: "street", sortable: true, width: "150px"},
          {text: "City", value: "city", sortable: true,width: "150px"},
          {text: "State", value: "state", sortable: true,width: "150px"},
          {text: "Zip", value: "zip", sortable: true,width: "150px"},
          {text: "Country", value: "country", sortable: true,width: "150px"}
        ]
      },
      customRenderers: [
        {
          field: "name",
        },
      ] 
    };
  },
  computed: {
    searchTrigger() {
      return this.search;
    }
  },
  async mounted() {

  },
  watch: {
    searchTrigger(q) {
      let componentEvent = this.$refs.dataTableComponent
      componentEvent.updateSearchField(q)
    }
  },
  methods: {
    exporItems() {
      if (this.items.length <= 0) {
        alert("No data to Export")
      }else{
        let items = [];
          for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i];
            items.push({
              id: item.id,
              name: item.name ,
              street: item.street ,
              city: item.city ,
              state: item.state ,
              zip: item.zip ,
              country: item.country ,
              sales: item.sales ,
              compset_configured: item.compset_configured ,
              pos_id: item.pos_id ,
              latitude: item.latitude ,
              longtitude: item.longtitude ,
              full_address: item.full_address
            });

          }
          let csv = this.$papa.unparse(items);
          this.$papa.download(
              csv,
              `LocationsReport-${moment().format("YYYY-MM-DD-HH-mm")}`
          );
      }
      
    },
    salesFormat(value) {
      if (value) {
        value = parseFloat(value);
        return money_format(value);
      } else {
        return "0.00";
      }
    },
    showDemographic(item) {
      this.$store.commit("setLocationId", item.id);
      window.sessionStorage.setItem("selected_location", item.id);
      // window.location.href = `/benchmark/demographics/?location_id=${item.id}`;
      this.$router.push(`/dashboard`);
    },
    showUpdateLocationModal(item) {
      this.item = item;
    },
    syncItems(itemsCollection) {
      this.items= itemsCollection
    }
  }
};
</script>

<template>
  <v-card flat>
    <div
        class="btn-toolbar justify-content-between mt-5"
        role="toolbar"
        aria-label="Toolbar with button groups"
    >
      <div class="btn-group" role="group" aria-label="First group">
        <v-btn class="mr-4" depressed tile small @click="exporItems()">
          <v-icon left> mdi-file</v-icon>
          Export
        </v-btn>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text" id="btnGroupAddon2">
            <b-icon icon="search"></b-icon>
          </div>
        </div>
        <b-form-input v-model="search" placeholder="Search"></b-form-input>
      </div>
    </div>

    <data-table-section
        :tableData="this.tableDataParam"
        :customRenderers="this.customRenderers"
        :isSelectEnabled="false"
        ref="dataTableComponent"
        @datatableItems="syncItems"
      >
      <template v-slot:nameparams="{ item }">
        <v-btn
            text
            color="primary"
            @click="showUpdateLocationModal(item)"
            v-b-modal.modal-update-location
        >
         {{ item.name.replace(item.street, '') }}
        </v-btn>
      </template>
    </data-table-section>
    <update-location-modal :item="item"></update-location-modal>
  </v-card>
</template>
